import dayjs from 'dayjs';
import { VerifyLoginRefusalReason, VerifyRefusalAction } from '../types/passwordless-login.types';

export const isLoginIdentifierValid = (value: string, emailRe: RegExp): boolean => {
  const trimmed = value.trim();
  if (!trimmed) return false;
  if (trimmed.includes('@')) {
    return emailRe.test(trimmed);
  }
  const digits = trimmed.replace(/\D/g, '');
  return digits.length >= 9 && digits.length <= 15;
};

export const formatRetryAt = (retryAt?: string | null): string => {
  if (!retryAt) return '';
  const ms = Number(retryAt);
  if (!Number.isFinite(ms)) return '';
  return dayjs(ms).format('HH:mm DD/MM/YYYY');
};

const REFUSAL_ACTIONS: Record<VerifyLoginRefusalReason, VerifyRefusalAction> = {
  [VerifyLoginRefusalReason.EXPIRED]: 'request-fresh',
  [VerifyLoginRefusalReason.ALREADY_CONSUMED]: 'request-fresh',
  [VerifyLoginRefusalReason.LOCKED]: 'locked',
  [VerifyLoginRefusalReason.WRONG_CODE_TOKEN]: 'keep-code',
  [VerifyLoginRefusalReason.SUBJECT_NOT_AMONG_RESOLVED]: 'stay-picker',
  [VerifyLoginRefusalReason.INVALID]: 'generic',
};

const REFUSAL_MESSAGE_KEYS: Record<VerifyLoginRefusalReason, string> = {
  [VerifyLoginRefusalReason.EXPIRED]: 'common.passwordlessExpired',
  [VerifyLoginRefusalReason.ALREADY_CONSUMED]: 'common.passwordlessAlreadyConsumed',
  [VerifyLoginRefusalReason.LOCKED]: 'common.passwordlessLocked',
  [VerifyLoginRefusalReason.WRONG_CODE_TOKEN]: 'common.passwordlessWrongCode',
  [VerifyLoginRefusalReason.SUBJECT_NOT_AMONG_RESOLVED]:
    'common.passwordlessSubjectNotAmongResolved',
  [VerifyLoginRefusalReason.INVALID]: 'common.passwordlessInvalid',
};

export const getVerifyRefusalAction = (reason: VerifyLoginRefusalReason): VerifyRefusalAction => {
  return REFUSAL_ACTIONS[reason] ?? 'generic';
};

export const getVerifyRefusalMessageKey = (reason: VerifyLoginRefusalReason): string => {
  return REFUSAL_MESSAGE_KEYS[reason] ?? 'common.passwordlessInvalid';
};
